import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography,
} from '@mui/material';
import React from 'react';
import PremiumReportingApi from '../../../api/PremiumReportingApi';
import { AuthData } from '../../../context/auth';
import {
	PremiumReportData,
	withPremiumReportContext,
} from '../../../context/premiumReport';
import { PRIMARY_BUTTON_STYLE } from '../../../data/constants';
import { errorToast, successToast } from '../../Toast';

interface Props {
	authData: AuthData;
	premiumReportData: PremiumReportData;
}

const ReverseReportModal = ({ authData, premiumReportData }: Props) => {
	const [open, setOpen] = React.useState(false);
	const [submitting, setSubmitting] = React.useState(false);
	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const reverseReport = async () => {
		setSubmitting(true);
		try {
			const response = await PremiumReportingApi.reversePremiumReport(
				authData.auth.authorizationToken,
				premiumReportData.premiumReport.locator,
			);
			if (response.status === 200) {
				handleClose();
				successToast('Successfully reversed report');
				premiumReportData.setPremiumReport(response.data);
				premiumReportData.fetchPremiumReports(response.data.policyLocator);
			}
		} catch (e) {
			errorToast(e.message);
		} finally {
			setSubmitting(false);
		}
		setSubmitting(false);
	};

	return (
		<>
			<Button color='primary' variant='contained' onClick={handleOpen}>
				Reverse
			</Button>
			<Dialog
				fullWidth
				open={open}
				onClose={handleClose}
				aria-labelledby='reverse-report-title'
			>
				<DialogTitle id='reverse-report-title'>Reverse Report</DialogTitle>
				<DialogContent>
					<Typography>
						Are you sure you want to reverse this premium report?
					</Typography>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={handleClose}
						color='primary'
						style={PRIMARY_BUTTON_STYLE}
						variant='contained'
						disabled={submitting}
					>
						Cancel
					</Button>
					<Button
						onClick={reverseReport}
						color='primary'
						style={PRIMARY_BUTTON_STYLE}
						variant='contained'
						disabled={submitting}
					>
						Reverse
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default withPremiumReportContext(ReverseReportModal);
